let obj = {};
obj.guarantPre = [
  // {
  //   key: '1',
  //   value: '1个月'
  // },
  // {
  //     key: '2',
  //     value: "2个月",
  // },
  // {
  //     key: '3',
  //     value: "3个月"
  // },
  // {
  //     key: '4',
  //     value: "4个月",
  // },
  // {
  //     key: '5',
  //     value: "5个月",
  // },
  // {
  //     key: '6',
  //     value: "6个月"
  // },
  // {
  //     key: '7',
  //     value: "7个月"
  // },
  // {
  //     key: '8',
  //     value: "8个月"
  // },
  // {
  //     key: '9',
  //     value: "9个月"
  // },
  // {
  //     key: '10',
  //     value: "10个月"
  // },
  // {
  //     key: '11',
  //     value: "11个月"
  // },
  {
    key: '12',
    value: '12个月'
  }
];
obj.companyTypeOptions = [
  {
    value: "I",
    name: "个人",
  },
  {
    value: "C",
    name: "企业",
  }
]
obj.companyIdTypeOptions = [
  {
      value: "03",
      name: "统一社会信用代码",
      type:'C'
  },
  {
      value: "01",
      name: "组织机构代码证",
      type:'C'
  },
  {
      value: "1",
      name: "身份证",
      type:'I'
  },
  {
      value: "2",
      name: "护照",
      type:'I'
  }
];
obj.occupationOptionsLevel = [
  {
    value: '2',
    name: '2类'
  }
];
obj.IdTypeOptions = [
  {
    value: '1',
    name: '身份证'
  },
  {
    value: '2',
    name: '护照'
  }
  // {
  //   value:'99',
  //   name:'其它'
  // },
];
obj.sexOptions = [
  {
    value: 'M',
    name: '男'
  },
  {
    value: 'F',
    name: '女'
  }
];
obj.plansValues = [
  {
    name: '境内旅行险-发现精彩(经济型)',
    value: 'LBFXJC1'
  },
  {
    name: '境内旅行险-发现精彩(普通型)',
    value: 'LBFXJC2'
  },
  {
    name: '境内旅行险-发现精彩(中端型)',
    value: 'LBFXJC3'
  },
  {
    name: '境内旅行险-发现精彩(精英型)',
    value: 'LBFXJC4'
  },
  {
    name: '境内旅行险-发现精彩(高端型)',
    value: 'LBFXJC5'
  }
];
export default { ...obj };
